// Components==============
import { MenuContext } from 'components/Layout/Menu/Menu';
import Button from 'components/UI/Button/Button';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import Modal from 'components/UI/Modal/Modal';
import React, { useContext, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import './PrintModal.module.scss';
// =========================

export default function PrintModal() {
    const { setPrintModalIsOpen } = useContext(MenuContext);

    const flashExercises = useSelector(
        (state: ReduxStore) => state.authentication?.user?.flash_exercises
    );

    const ref = useRef<HTMLDivElement>(null);

    const [selected, setSelected] = useState<number[]>([]);

    const handlePrint = () => {
        selected.forEach((s) => {
            const a = document.createElement('a');
            a.href = `/helpers/flitsPDF/${s}`;
            a.appendChild(document.createTextNode(`${s}`));
            a.download = 'true';
            ref.current?.append(a);
            a.click();
        });

        setPrintModalIsOpen(false);
    };

    return (
        <Modal setModalIsOpen={setPrintModalIsOpen}>
            <div styleName="wrapper" ref={ref}>
                <h2>Flitsprogramma afdrukken</h2>
                <p>
                    Wil je de woordenlijsten offline oefenen, dat kan. Selecteer
                    de flitsprogramma's die je wil afdrukken.
                </p>
                <div styleName="icons">
                    {flashExercises?.map((exercise, index) => (
                        <CircleButton
                            onClick={() =>
                                setSelected((prev) =>
                                    prev.includes(exercise.id)
                                        ? prev.filter((p) => p !== exercise.id)
                                        : [...prev, exercise.id]
                                )
                            }
                            color={
                                selected.includes(exercise.id) ? 'blue' : 'grey'
                            }
                            key={index}
                        >
                            <h6>{index + 1}</h6>
                        </CircleButton>
                    ))}
                </div>
                <div styleName="button-wrapper">
                    <Button
                        lightgrey
                        onClick={() => setPrintModalIsOpen(false)}
                    >
                        Annuleren
                    </Button>

                    <Button onClick={handlePrint}>Afdrukken</Button>
                </div>
            </div>
        </Modal>
    );
}
